import Vue from 'vue'
import commonResource from '@/resources/common'
import day6Resource from '@/resources/day6'

const openInvalidDimensionsDialogId = 'open-invalid-dimensions'
const feedbackSurveyDialogId = 'feedback-survey'
const loadLatestDimensionsId = 'load-latest-dimensions'
const pendingPoseEstimateId = 'pending-pose-estimate'
const pendingGenerateLocomotionId = 'pending-generate-locomotion'
const newCharacterSaveChangesDialogId = 'new-character-save-changes'
const loadCharacterSaveChangesDialogId = 'load-character-save-changes'
const loadPoseSequenceSaveChangesDialogId = 'load-pose-save-changes'
const newPoseSequenceSaveChangesDialogId = 'new-pose-save-changes'
const buildPoseSaveChangesDialogId = 'build-pose-save-changes'
const closeModalDialogId = 'close-modal'
const openAccountPayDialogId = 'open-account-pay'

const mixin = {
  data: function () {
    return {
      showInfoDialog: false,
      showMailingListDialog: false,
      showPoseEstimateDialog: false,
      showDataBrowser: false,
      showAssetBuildTimeEstimateDialog: false,
      persistentDialogMessage: '',
      isSurveyRequested: false,
      snackbar: false,
      snackbarTimeout: 3000,
      snackbarText: ''
    }
  },
  computed: {
    showPersistentDialog () {
      return !!this.persistentDialogMessage
    }
  },
  watch: {
    // Focus on Unity when dialogs are dismissed
    showInfoDialog (val) {
      if (!val) { this.focusUnity() }
    },
    showMailingListDialog (val) {
      if (!val) { this.focusUnity() }
    },
    showPoseEstimateDialog (val) {
      if (!val) { this.focusUnity() }
    },
    showDataBrowser (val, prev) {
      if (!val) { this.focusUnity() }
    }
  },
  methods: {
    showSnackbar (message) {
      this.snackbarText = message
      this.snackbar = true
    },
    invalidDimensionsDialog () {
      this.$refs.fullDialog.showDialogProperties({
        message: day6Resource.invalidCharacterLink,
        positiveAction: commonResource.ok,
        id: openInvalidDimensionsDialogId
      })
    },
    surveyDialog () {
      // Don't bug paying users
      if (this.isAccountPaid) { return }

      this.isSurveyRequested = true
      this.$refs.fullDialog.showDialogProperties({
        message: day6Resource.takeFeedbackSurvey,
        id: feedbackSurveyDialogId,
        isHtmlMessage: true
      })
    },
    async runInModalDialog (ops, message, postOps) {
      this.persistentDialogMessage = message
      try {
        const result = await ops()
        return result
      } finally {
        this.persistentDialogMessage = ''
        if (postOps) {
          postOps()
        }
      }
    },
    async runInLoadingDialog (ops, message, postOps) {
      return this.runInModalDialog(ops, message || day6Resource.loadingDotDotDot, postOps)
    },
    _saveChangesDialog (dialogId) {
      this.$refs.fullDialog.showDialogProperties({
        message: day6Resource.promptSaveChanges,
        positiveAction: commonResource.yes,
        negativeAction: commonResource.no,
        id: dialogId
      })
    },
    newCharacterSaveChangesDialog () {
      this._saveChangesDialog(newCharacterSaveChangesDialogId)
    },
    loadCharacterSaveChangesDialog () {
      this._saveChangesDialog(loadCharacterSaveChangesDialogId)
    },
    loadPoseSaveChangesDialog () {
      this._saveChangesDialog(loadPoseSequenceSaveChangesDialogId)
    },
    newPoseSaveChangesDialog () {
      this._saveChangesDialog(newPoseSequenceSaveChangesDialogId)
    },
    toggleBuildPoseSaveChangesDialog () {
      this._saveChangesDialog(buildPoseSaveChangesDialogId)
    },
    loadLatestDimensionsDialog () {
      if (!this.latestDimensionsData[this.latestDimensionCheckId]) { return }

      this.$refs.fullDialog.showDialogProperties({
        message: day6Resource.askLoadLatest,
        positiveAction: commonResource.yes,
        negativeAction: commonResource.no,
        id: loadLatestDimensionsId
      })
    },
    // Show dialog about blocking action not a blocking/persistent/modal dialog
    _showBlockingDialog (message, dialogId) {
      this.$refs.fullDialog.showDialogProperties({
        message,
        positiveAction: day6Resource.abort,
        negativeAction: commonResource.no,
        id: dialogId
      })
    },
    poseEstimateApplyPendingDialog () {
      this._showBlockingDialog(day6Resource.pendingPoseEstimateApply, pendingPoseEstimateId)
    },
    generateLocomotionPendingDialog () {
      this._showBlockingDialog(day6Resource.pendingGenerateLocomotion, pendingGenerateLocomotionId)
    },
    showOkDialog (message) {
      this.$refs.fullDialog.showMessageOkDialog(message)
    },
    animationGenerationInProgressDialog () {
      this.showOkDialog(day6Resource.animationGenerationInProgress)
    },
    paidFeatureDialog (message) {
      this.$refs.fullDialog.showDialogProperties({
        message,
        positiveAction: day6Resource.start,
        negativeAction: commonResource.close,
        id: openAccountPayDialogId
      })
    },
    characterChangeDuringDownloadDialog () {
      this.showOkDialog(day6Resource.characterChangeDownloadAgain)
    },
    previewNotSupportedDialog () {
      this.showOkDialog(day6Resource.characterPreviewNotSupported)
    },
    accountStateErrorDialog () {
      this.showOkDialog(day6Resource.checkConnectionRefresh)
    },
    accountSharingNotSupportedDialog () {
      this.showOkDialog(day6Resource.accountSharingNotReady)
    },
    unityLoadErrorDialog () {
      this.showOkDialog(day6Resource.unityLoadErrorDescription)
    },
    loadPoseSequenceFailDialog () {
      this.showOkDialog(day6Resource.loadPoseSequenceFailTryAgain)
    },
    deletePoseSequenceFailDialog () {
      this.showOkDialog(day6Resource.deletePoseSequenceFailTryAgain)
    },
    noSavingSmallScreenAnimationsDialog () {
      this.showOkDialog(day6Resource.noSavingSmallScreenAnimations)
    },
    previewAnimationLoadFailDialog () {
      this.showOkDialog(day6Resource.issuePreviewingAnimation)
    },
    confirmCloseModalDialog (modalKey, callbackAction) {
      let message = ''
      switch (modalKey) {
        case 'apply-pose-estimate':
          message = day6Resource.confirmAbortPoseEstimate
          break
        case 'generate-locomotion':
          message = day6Resource.confirmAbortGenerateAnimation
          break
        default:
          Vue.logger.error(new Error(`Unrecognized modal ${modalKey} is open`))
          break
      }

      if (message) {
        this._closeModalDialogDescription = {
          modalKey,
          callbackAction
        }
        this.$refs.fullDialog.showDialogProperties({
          message,
          positiveAction: commonResource.yes,
          negativeAction: commonResource.no,
          id: closeModalDialogId
        })
      }
    },
    continueCloseModalDialog () {
      const { modalKey, callbackAction } = this._closeModalDialogDescription || {}

      switch (modalKey) {
        case 'apply-pose-estimate':
          this.unityCancelPoseEstimate()
          break
        case 'generate-locomotion':
          this.unityCancelLocomotionGeneration()
          break
      }

      if (callbackAction) {
        callbackAction()
      }
    },
    onDialogAction (dialogData) {
      switch (dialogData.id) {
        case openInvalidDimensionsDialogId:
          this.$router.replace({ name: 'day6-main' })
          // Data loading and Unity loading may be out of sync
          this.unitySyncLocalState()
          break
        case loadLatestDimensionsId:
          if (dialogData.action > 0) {
            const { latestId } = this.latestDimensionsData[this.latestDimensionCheckId]
            this.openBodyDimensions(latestId)
          }
          break
        case pendingPoseEstimateId:
          if (dialogData.action > 0) {
            this.unityCancelPoseEstimate()
            // TODO Continue with action prior to dialog
          }
          break
        case pendingGenerateLocomotionId:
          if (dialogData.action > 0) {
            this.unityCancelLocomotionGeneration()
            // TODO Continue with action prior to dialog
          }
          break
        case newCharacterSaveChangesDialogId:
          if (dialogData.action > 0) {
            this.saveChangesNewCharacter()
          } else if (dialogData.action < 0) {
            this.continueNewCharacter()
          }
          break
        case loadCharacterSaveChangesDialogId:
          if (dialogData.action > 0) {
            this.saveChangesLoadCharacter()
          } else if (dialogData.action < 0) {
            this.continueLoadingCharacter()
          }
          break
        case loadPoseSequenceSaveChangesDialogId:
          if (dialogData.action > 0) {
            this.saveChangesLoadPoseSequence()
          } else if (dialogData.action < 0) {
            this.continueLoadingPoseSequence()
          }
          break
        case newPoseSequenceSaveChangesDialogId:
          if (dialogData.action > 0) {
            this.saveChangesNewPoseSequence()
          } else if (dialogData.action < 0) {
            this.continueNewPoseSequence(true)
          }
          break
        case buildPoseSaveChangesDialogId:
          if (dialogData.action > 0) {
            this.onToggleBuildPoseAction()
          } else if (dialogData.action < 0) {
            this.continueToBuildPose()
          }
          break
        case closeModalDialogId:
          if (dialogData.action > 0) {
            this.continueCloseModalDialog()
          } else {
            this._closeModalDialogDescription = null
          }
          break
        case openAccountPayDialogId:
          if (dialogData.action > 0) {
            this.openAccountPay()
          }
          break
      }
    },
    onDialogClose () {
      this.focusUnity()
    },
    onEstimatePoseAction (action) {
      if (action === -1) {
        this.isEstimatingPose = false
      }
      this.showPoseEstimateDialog = false
    }
  }
}

export default mixin
